import immutableUpdate from 'react-addons-update';
import moment from 'moment';
import {
  SET_ORDER_DETAILS,
  SET_SELECTED_OPTION,
  SET_SELECTED_VARIANT,
  SET_SELECTED_LOCATION,
  SET_SELECTED_RESOURCE,
  SET_TIMESLOT,
  SET_DATE_RANGE,
  SET_SELECTED_TERM,
  SET_BOOKING_FIELDS,
  SET_BOOKINGS,
} from '../actions/orders';

const initialState = {
  totalPrice: 0,
  date: null,
  available: 0,
  totalQuantity: 0,
  variants: {},
  timeSlot: null,
  selectedTimeslot: null,
  variantSelected: null,
  selectedLocation: null,
  selectedResource: null,
  termSelected: {},
  bookingFields: [],
  bookings: [],
  currentMonth: moment(Date.now()).startOf('month'),
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ORDER_DETAILS:
      return {
        ...state,
        ...action.value,
      };

    case SET_SELECTED_OPTION:
      return immutableUpdate(state, {
        selectedTimeslot: { $set: action.value },
      });

    case SET_SELECTED_VARIANT:
      return immutableUpdate(state, {
        variantSelected: { $set: action.value },
      });

    case SET_SELECTED_LOCATION:
      return immutableUpdate(state, {
        selectedLocation: { $set: action.value },
      });

    case SET_SELECTED_RESOURCE:
      return immutableUpdate(state, {
        selectedResource: { $set: action.value },
      });

    case SET_SELECTED_TERM:
      return immutableUpdate(state, {
        termSelected: { $set: action.value },
      });

    case SET_TIMESLOT:
      return immutableUpdate(state, {
        timeSlot: { $set: action.value },
      });
    case SET_DATE_RANGE:
      return immutableUpdate(state, {
        dateRange: { $set: action.value },
      });
    case SET_BOOKING_FIELDS:
      return immutableUpdate(state, {
        bookingFields: { $set: action.value },
      });
    default:
      return state;
  }
}
